// InstallationDetails.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Grid, TextField, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import config from "../../config.js";

export default function InstallationDetails({
    formData,
    handleInputChange,
    RequiredLabel,
    StandardLabel,
    errors = {},
    t,
    selectedOrganization,
    setSelectedOrganization
}) {
    const [organizations, setOrganizations] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sites, setSites] = useState([]);
    const [cities, setCities] = useState([]);
    console.log(formData, "hboshbd")
    useEffect(() => {
        // Load initial organization data
        fetchOrganization();

        // If we have a selected organization, fetch its vehicles and sites
        if (selectedOrganization?.id) {
            fetchOrganizationVehicles(selectedOrganization.id);
            fetchSites(selectedOrganization.id);
        }
    }, [selectedOrganization]);

    // Fetch organization-specific data when organization changes
    useEffect(() => {
        if (selectedOrganization?.id) {
            fetchOrganizationVehicles(selectedOrganization.id);
            fetchSites(selectedOrganization.id);

            // Auto-populate city from organization data
            if (selectedOrganization.city) {
                const cityEvent = { target: { value: selectedOrganization.city } };
                handleInputChange(cityEvent, 'city');
            }
        } else {
            // Clear dependent fields when no organization is selected
            setVehicles([]);
            setSites([]);
            const cityEvent = { target: { value: '' } };
            handleInputChange(cityEvent, 'city');
        }
    }, [selectedOrganization]);

    const fetchOrganizationVehicles = async (organizationId) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.baseURL}/vehicle/organization/independent/${organizationId}`,
                { withCredentials: true }
            );

            const vehicleData = response?.data?.vehicles || response?.data || [];
            setVehicles(vehicleData);

            // Auto-select if there's only one vehicle
            if (vehicleData.length === 1) {
                const singleVehicle = vehicleData[0];
                const vehicleInfo = {
                    id: singleVehicle.id,
                    name: singleVehicle.name,
                    registrationNumber: singleVehicle.VehicleNumber,
                    model: singleVehicle.Model
                };

                // Update form with vehicle data
                handleInputChange({ target: { value: vehicleInfo } }, 'vehicle');
                handleInputChange({
                    target: { value: singleVehicle.VehicleNumber || '' }
                }, 'vehicleRegistrationNumber');
                handleInputChange({
                    target: { value: singleVehicle.Model || '' }
                }, 'vehicleModel');
            }
        } catch (error) {
            console.log('Error fetching organization vehicles:', error);
            setVehicles([]);
        } finally {
            setLoading(false);
        }
    };

    const handleVehicleSelect = (event) => {
        const selectedVehicleName = event.target.value;
        const selectedVehicle = vehicles.find(vehicle => vehicle.name === selectedVehicleName);

        // Create a complete vehicle object
        const vehicleData = selectedVehicle ? {
            id: selectedVehicle.id,
            name: selectedVehicle.name,
            registrationNumber: selectedVehicle.VehicleNumber,
            model: selectedVehicle.Model
        } : null;

        // Update form with vehicle data
        handleInputChange({ target: { value: vehicleData } }, 'vehicle');

        if (selectedVehicle) {
            handleInputChange({
                target: { value: selectedVehicle.VehicleNumber || '' }
            }, 'vehicleRegistrationNumber');

            handleInputChange({
                target: { value: selectedVehicle.Model || '' }
            }, 'vehicleModel');

            // If vehicle has organization data, update organization fields
            if (selectedVehicle.organization) {
                handleInputChange({
                    target: { value: selectedVehicle.organization.name }
                }, 'organizationName');

                handleInputChange({
                    target: { value: selectedVehicle.organization.city }
                }, 'city');
            }
        } else {
            // Clear all vehicle-related fields
            handleInputChange({ target: { value: '' } }, 'vehicleRegistrationNumber');
            handleInputChange({ target: { value: '' } }, 'vehicleModel');
        }
    };

    const handleSingleSite = (sites) => {
        if (sites.length === 1) {
            // Automatically select the only site
            handleInputChange({ target: { value: sites[0].siteId } }, 'site');
        }
    };

    const fetchSites = async (organizationId) => {
        try {
            const response = await axios.get(
                `${config.baseURL}/site/organization?organizationId=${organizationId}`,
                { withCredentials: true }
            );
            const siteData = Array.isArray(response.data) ? response.data : [];
            setSites(siteData);

            // Auto-select if there's only one site
            if (siteData.length === 1) {
                handleSingleSite(siteData);
            }
        } catch (error) {
            console.error('Error fetching sites:', error);
            setSites([]);
        }
    };


    const fetchOrganization = async () => {
        try {
            const response = await axios.get(`${config.baseURL}/organization`);
            setOrganizations(response?.data?.organizations || []);
        } catch (error) {
            console.log('Error fetching organizations:', error);
            setOrganizations([]);
        }
    };

    const handleOrganizationSelect = (event) => {
        const orgName = event.target.value;
        const selectedOrg = organizations.find(org => org.name === orgName);

        setSelectedOrganization(selectedOrg);
        handleInputChange({ target: { value: orgName } }, 'organizationName');

        // Set cities from the organization
        if (selectedOrg?.cities?.length) {
            setCities(selectedOrg.cities);
            // If only one city, auto-select it
            if (selectedOrg.cities.length === 1) {
                handleInputChange({ target: { value: selectedOrg.cities[0] } }, 'city');
            }
        } else if (selectedOrg?.city) {
            // If organization has a single city
            setCities([selectedOrg.city]);
            handleInputChange({ target: { value: selectedOrg.city } }, 'city');
        } else {
            setCities([]);
        }
    };

    const inputStyles = {
        '& .MuiOutlinedInput-root': {
            height: "55px",
            borderRadius: '16px',
            padding: '16px 24px',
            border: '2px solid #183059',
            '&:hover': {
                border: '2px solid #183059',
            },
            '&.Mui-focused': {
                border: '2px solid #183059',
            },
            '& fieldset': {
                border: 'none !important',
            },
        },
        '& .MuiInputBase-input': {
            padding: 0,
        },
    };

    const selectStyles = {
        height: "55px",
        borderRadius: '16px',
        border: '2px solid #183059',
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiSelect-select': {
            padding: '16px 24px',
            paddingRight: '48px !important',
            display: 'flex',
            alignItems: 'center',
            height: '23px',
        },
    };

    const displayBoxStyles = {
        height: "55px",
        borderRadius: '16px',
        backgroundColor: "#E8EAEE",
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        minHeight: '55px',
        boxSizing: 'border-box',
        fontSize: '16px',
        fontFamily: 'inherit',
    };

    useEffect(() => {
        // Set selected organization if editing
        if (formData.organizationName && organizations.length > 0) {
            const org = organizations.find(o => o.name === formData.organizationName);
            if (org && (!selectedOrganization || org.id !== selectedOrganization.id)) {
                setSelectedOrganization(org);
            }
        }
    }, [formData.organizationName, organizations]);

    useEffect(() => {
        // Set vehicles after fetching and set selected vehicle if editing
        if (formData.vehicle && vehicles.length > 0) {
            const v = vehicles.find(v => v.id === formData.vehicle.id);
            if (v && (!formData.vehicle.name || v.name !== formData.vehicle.name)) {
                // Update vehicle name in formData if needed
                handleInputChange({ target: { value: { id: v.id, name: v.name } } }, 'vehicle');
            }
        }
        // eslint-disable-next-line
    }, [vehicles, formData.vehicle]);

    return (
        <Box
            sx={{
                padding: { xs: '20px', md: '40px' },
                margin: { xs: '0px 20px', md: '0px 40px' },
                backgroundColor: '#FFFFFF',
                border: '1px solid #A5DCF3',
                borderRadius: '10px',
                boxShadow: '-2px 2px 5px 0px #00000040',
                mb: 3,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Paper
                    sx={{
                        height: 52,
                        width: '100%',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        backgroundColor: '#647490',
                        boxShadow: '-2px 2px 5px 0px #00000040',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="white"
                        sx={{ fontSize: { xs: '18px', md: '20px' } }}
                    >
                        {t('Installation Details')}
                    </Typography>
                </Paper>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3} mb={1}>
                                <StandardLabel label={t('Date')} />
                                <TextField
                                    fullWidth
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    value={formData.installationDate}
                                    onChange={(e) => handleInputChange(e, 'installationDate')}
                                    error={!!errors.installationDate}
                                    helperText={errors.installationDate}
                                    sx={inputStyles}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} mb={1.5}>
                                <StandardLabel label={t('Organization Name')} />
                                <Select
                                    fullWidth
                                    variant="outlined"
                                    displayEmpty
                                    value={formData.organizationName || ''}
                                    onChange={handleOrganizationSelect}
                                    sx={selectStyles}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span style={{ color: '#999' }}>{t('Select Organization')}</span>;
                                        }
                                        return selected;
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        {t('Select Organization')}
                                    </MenuItem>
                                    {organizations?.map((org) => (
                                        <MenuItem key={org.id} value={org.name}>
                                            {org.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={12} sm={3} mb={1.5}>
                                <StandardLabel label={t('City')} />
                                {cities.length === 1 ? (
                                    <Box sx={{
                                        ...displayBoxStyles,
                                        color: '#000'
                                    }}>
                                        {cities[0]}
                                    </Box>
                                ) : (
                                    <Select
                                        fullWidth
                                        variant="outlined"
                                        displayEmpty
                                        value={formData.city || ''}
                                        onChange={(e) => handleInputChange(e, 'city')}
                                        sx={selectStyles}
                                        disabled={!selectedOrganization}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return (
                                                    <span style={{ color: '#999' }}>
                                                        {!selectedOrganization ? t('Select Organization First') : t('Select City')}
                                                    </span>
                                                );
                                            }
                                            return selected;
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            {!selectedOrganization ? t('Select Organization First') : t('Select City')}
                                        </MenuItem>
                                        {cities.map((city) => (
                                            <MenuItem key={city} value={city}>
                                                {city}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={3} mb={1}>
                                <StandardLabel label={t('Site')} />
                                {sites.length === 1 ? (
                                    // Display single site as read-only box
                                    <Box sx={{
                                        ...displayBoxStyles,
                                        color: '#000'
                                    }}>
                                        {sites[0].name}
                                    </Box>
                                ) : (
                                    // Show dropdown for multiple sites
                                    <Select
                                        fullWidth
                                        variant="outlined"
                                        displayEmpty
                                        value={formData.site || ''}
                                        onChange={(e) => handleInputChange(e, 'site')}
                                        sx={selectStyles}
                                        disabled={!selectedOrganization || sites.length === 0}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return (
                                                    <span style={{ color: '#999' }}>
                                                        {!selectedOrganization ? t('Select Organization First') : t('Select Site')}
                                                    </span>
                                                );
                                            }
                                            const selectedSite = sites.find((site) => site.siteId === selected);
                                            return selectedSite ? selectedSite.name : selected;
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            {!selectedOrganization ? t('Select Organization First') : t('Select Site')}
                                        </MenuItem>
                                        {sites?.map((site) => (
                                            <MenuItem key={site.id} value={site.siteId}>
                                                {site.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Vehicle Name')} />
                                {vehicles.length === 1 ? (
                                    <Box sx={{
                                        ...displayBoxStyles,
                                        color: '#000'
                                    }}>
                                        {vehicles[0].name}
                                    </Box>
                                ) : (
                                    <Select
                                        fullWidth
                                        variant="outlined"
                                        displayEmpty
                                        value={formData.vehicle?.name || ''}
                                        onChange={handleVehicleSelect}
                                        sx={selectStyles}
                                        disabled={!selectedOrganization || vehicles.length === 0}
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <span style={{ color: '#999' }}>
                                                    {!selectedOrganization ? t('Select Organization First') : t('Select Vehicle')}
                                                </span>;
                                            }
                                            return selected;
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            {!selectedOrganization ? t('Select Organization First') : t('Select Vehicle')}
                                        </MenuItem>
                                        {vehicles?.map((vehicle) => (
                                            <MenuItem key={vehicle.id} value={vehicle.name}>
                                                {vehicle.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Vehicle Registration Number')} />
                                <Box sx={{
                                    ...displayBoxStyles,
                                    color: formData.vehicleRegistrationNumber ? '#000' : '#95A0B3'
                                }}>
                                    {formData.vehicleRegistrationNumber || 'e.g WB26AG1234'}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Vehicle Model')} />
                                <Box sx={{
                                    ...displayBoxStyles,
                                    color: formData.vehicleModel ? '#000' : '#95A0B3'
                                }}>
                                    {formData.vehicleModel || 'e.g Tata Ace Gold'}
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} mb={1.5}>
                                <StandardLabel label={t('Remarks')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('typeRemarks')}
                                    value={formData.remarks || ''}
                                    onChange={(e) => handleInputChange(e, 'remarks')}
                                    multiline
                                    rows={4}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.remarks ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.remarks ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.remarks ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }}
                                    error={!!errors.remarks}
                                    helperText={errors.remarks}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}